import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  outline: 0;
  z-index: 7000;

  @media (max-width: 1023px) {
    padding: 0 25px;
    background-color: #000;
  }

  @media (min-width: 1024px) {
    background-color: rgba(0, 0, 0, 0.3);
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
  }
`;

export const Dialog = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow-y: auto;

  @media (max-width: 1023px) {
    height: calc(100% - 96px);
  }

  @media (min-width: 1024px) {
    width: calc(100% - 120px);
    height: calc(100% - 96px);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-height: 100%;
  outline: 0;

  @media (min-width: 1024px) {
    max-width: 1440px;
  }
`;

export const Close = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  color: #c3c3c3;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 2000;

  @media (max-width: 1023px) {
    position: fixed;
    top: 25px;
    right: 25px;
    width: 30px;
    height: 30px;
    font-size: 30px;
  }

  @media (min-width: 1024px) {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 50px;
    height: 50px;
    font-size: 18px;
  }
`;

export const Body = styled.div`
  @media (max-width: 1023px) {
    .slick-prev {
      left: 16px !important;
    }

    .slick-next {
      right: 16px !important;
    }
  }

  @media (max-width: 639px) {
    .slick-next,
    .slick-prev {
      top: 100px;
    }
  }

  @media (min-width: 640px) {
    .slick-next,
    .slick-prev {
      top: 130px;
    }
  }

  @media (min-width: 1024px) {
    .slick-next,
    .slick-prev {
      top: auto;
      bottom: -87px;
    }

    .slick-prev {
      left: 0 !important;
    }

    .slick-next {
      right: 0 !important;
    }
  }

  @media (min-width: 1600px) {
    max-width: 1440px;
    margin: 0 auto;
  }
`;

export const Slide = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  @media (min-width: 1024px) {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    height: 600px;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 639px) {
    height: 230px;
  }

  @media (min-width: 640px) and (max-width: 1023px) {
    height: 300px;
  }
`;

export const Image = styled.img`
  @media (max-width: 1023px) {
    width: auto;
    height: 100%;
    max-width: 440px;
  }

  @media (min-width: 1024px) {
    width: 100%;
    height: auto;
    max-width: 470px;
  }
`;

export const RecipeContainer = styled.div`
  width: 100%;
  background-color: #202020;
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 1023px) {
    padding: 35px 20px 26px;
    background-size: auto 70%;
  }

  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 48px 73px 42px 65px;
    background-size: auto 70%;
  }
`;

export const RecipeBody = styled.div`
  @media (min-width: 1024px) {
    width: 100%;
    max-width: 480px;
  }
`;

export const Title = styled.div`
  color: #fff;
  font-family: "YWFT Ultramagnetic";
  text-transform: uppercase;

  @media (max-width: 1023px) {
    font-size: 24px;
    line-height: 1.25;
  }

  @media (min-width: 1024px) {
    font-size: 34px;
    line-height: 1.29;
  }
`;

export const RecipeBlock = styled.div`
  @media (max-width: 1023px) {
    margin-top: 20px;
  }

  @media (min-width: 1024px) {
    margin-top: 45px;
  }
`;

export const RecipeTitle = styled.div`
  color: #c49f3f;
  font-family: "Rockwell";
  font-weight: 500;
  text-transform: uppercase;

  @media (max-width: 1023px) {
    font-size: 14px;
    line-height: 2.5;
    letter-spacing: 1.12px;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    line-height: 1.75;
    letter-spacing: 1.6px;
  }
`;

export const RecipeList = styled.ul`
  list-style: none;

  @media (max-width: 1023px) {
    margin-top: 6px;
  }

  @media (min-width: 1024px) {
    margin-top: 10px;
  }
`;

export const RecipeListItem = styled.li`
  @media (max-width: 1023px) {
    color: #fff;
    font-size: 14px;
    line-height: 1.57;
  }

  @media (min-width: 1024px) {
    color: #c3c3c3;
    font-size: 15px;
    line-height: 1.75;
    letter-spacing: 0.32px;
  }
`;
